import { render, staticRenderFns } from "./TabPreautorizzato.vue?vue&type=template&id=22e24a30&"
import script from "./TabPreautorizzato.vue?vue&type=script&lang=js&"
export * from "./TabPreautorizzato.vue?vue&type=script&lang=js&"
import style0 from "./TabPreautorizzato.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabPreautorizzato.vue
// module id = 893
// module chunks = 0